<template>
    <div></div>
</template>


<script>
export default {
    data(){
        return{
            targetUrl:'',
        }
    },
    created(){
        this.targetUrl = this.$route.query.url;
        let token = localStorage.getItem("token");
        if (!token) {
            this.$router.replace({
                path:'/login',
            })
            return;
        }
		this.$api.homeGetEmpInfo({platform:2}).then(res=>{
			if(res.data.code==1){
				let info = res.data.data;
				if(info.type==1){
					this.$global.userType = 1;
					this.$global.rank = -1;
					let obj = [
						'addOrder',
						'seeOrderDetail',
						'order',
						'cDelete',
						'paymentList'
					]
					this.$global.user = obj;
					this.$global.id = info.id;
					this.$global.name = info.cname;
				}else if(info.type==0){
					this.$global.userType = 0;
					this.$global.rank = info.rank;
					this.$global.user = info.permissions;
					this.$global.id = info.id;
					this.$global.name = info.name;
					let bt = localStorage.getItem('ipad_buytype');
					if(bt!=null){
						this.$global.buyType = parseInt(bt);
					}else{
						this.$global.buyType = 1;
					}
				}
				this.$global.cmpId.cmp = info.cmp;
                let spcart = JSON.parse(localStorage.getItem('shopingcart'));
		        this.$global.shoppingCartNumber = spcart==null?0:spcart.length;
				if(info.showPrice === 0){
					this.$global.showProductPrice = false;
				}else{
					this.$global.showProductPrice = true;
				}
				this.init();
			}
		})
    },
	methods:{
		init(){
			let arr = [{
				str:'/mobile/system/getCustomerProduct',
				func:(res)=>{
					if(res.data.code==1){
						let info = res.data.data;
						if(info.basicPack&&info.defaultPack){
							this.$global.unit = info.basicPack;
							this.$global.pack = info.defaultPack;
						}
						if(info.useinstall!=null){
							this.$global.useinstall = info.useinstall;
						}
					}
				}
			}];
			if(this.$global.userType==0){
				arr.push(
					{
						str:'/emp/system/getDataStorage',
						data:{
							key:'customerMobileShow',
							share:0,
						},
						func:(res)=>{
							let str = res.data.data.customerMobileShow;
							this.$global.customerState = str?str:'';
						}
					}
				)
			}
			this.$api.getInfoByPost(arr,()=>{
				this.$common.success('欢迎登录');
				this.$router.replace({
					path:this.targetUrl,
				})
			});
		},
	}
}
</script>
